export default __webpack_public_path__ + "static/media/logo.cc4dac4d.png";